import cx from 'classnames'
import React, {Component} from 'react'
import Types from '../../types'

import './styles.css'

// TODO(jong): kill link type, in favor of a Link component
class AnchorButton extends Component {
  static propTypes = {
    children: Types.node,
    className: Types.string,
    href: Types.string,
  }

  render() {
    const {children, className, href, ...rest} = this.props
    return (
      <a
        {...rest}
        href={href}
        target='_blank'
        rel='noopener noreferrer'
        className={cx('anchor-button', className)}
      >
        {children}
      </a>
    )
  }
}

export default AnchorButton



// WEBPACK FOOTER //
// ./src/components/AnchorButton/index.js